<template>
  <div
  :style="{
    display: 'block',
    backgroundImage: `url('${src}')`,
    paddingBottom: '100%',
    width: '100%',
    minWidth: '100%',
    backgroundSize: 'cover',
    minHeight: '10px'
  }"
/>
</template>

<script>
export default {
  name: 'Photo',
  props: {
    src: String,
  },
};
</script>
